import styled from "styled-components";
import { darkModeColors } from "../../consts";

const Paragraph1 = styled.p`
  font-size: 20px;
  line-height: 30px;
`;

const Paragraph2 = styled.p`
  font-size: 16px;
  line-height: 26px;
`;

const Caption = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  color: ${darkModeColors.EMPEROR_WHITE};
`;

export { Paragraph1, Paragraph2, Caption };
